import Generator from '@/views/dashboard/Generator/index'
import GraphicDetails from '@/views/dashboard/Graphics/GraphicDetails'
import GraphicsList from '@/views/dashboard/Graphics/GraphicsList'
import ViewersPage from '@/views/dashboard/Viewers'
import HomePage from '@/views/home'
import Login from '@/views/login/Login'
import paths from './paths'

const createRoute = (path: string, component: React.ComponentType) => ({
  path,
  component
})

/**
 * Routes configuration object.
 */
const routes = {
  public: [],
  nonAuthenticated: [createRoute(paths.LOGIN, Login)],
  authenticated: [
    createRoute(paths.GENERATOR, Generator),
    createRoute(paths.GRAPHICS, GraphicsList),
    createRoute(paths.GRAPHICS_ID, GraphicDetails),
    createRoute(paths.VIEWERS, ViewersPage),
    createRoute(paths.HOME, HomePage)
  ]
}

export default routes
